(function () {
    const BASE = (typeof window !== 'undefined' && window.__AG_API) 
      ? window.__AG_API 
      : 'https://api.agstark.com'; // extra safety default to PROD
  
    async function agFetch(path, options = {}) {
      const url = `${BASE}${path.startsWith('/') ? path : `/${path}`}`;
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(options.headers || {}),
      };
      const res = await fetch(url, { ...options, headers });
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`AG API ${res.status}: ${text || res.statusText}`);
      }
      // Try JSON, fall back to text
      try { return await res.json(); } catch { return await res.text(); }
    }
  
    // Expose a tiny SDK
    window.AG = {
      BASE,          // e.g., "https://stagingapi.agstark.com"
      fetch: agFetch // usage: AG.fetch('/api/...', { method: 'POST', body: JSON.stringify({...}) })
    };
  })();